import { trackSuccessSendCustomAction } from '../actions/userCard/tracking';
import { fetchChatsCustomAction, TChatsCustomActionResponse } from '../repositories/chats/v1/chats/custom-action';
import { currentChatOpponentIdSelector, currentOpenChatSelector, customActionsSelector } from '../selectors';
import { showAlert } from '../slices/alertSlice';
import { EAlert } from '../types/alert';
import { ECustomAction } from '../types/customActions';
import { TThunkAction } from '../types/redux/thunk';

type TSendCustomActionParams = {
  action: ECustomAction;
  chatId: string;
  companionId: number | undefined;
};

export const sendCustomActions =
  ({ action, chatId, companionId }: TSendCustomActionParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const state = getState();

    const customActions = customActionsSelector(state);
    const currentChat = currentOpenChatSelector(state);
    const opponentId = currentChatOpponentIdSelector(state);

    const button = customActions ? customActions.find(button => button.action === action) : undefined;

    try {
      const { response, statusCode }: TChatsCustomActionResponse = await fetchChatsCustomAction({
        httpApi,
        parameters: {
          action,
          chatId,
        },
        config: {
          requestConfig: {
            withCredentials: true,
          },
        },
      });

      if (statusCode !== 200) {
        logger.warning(response.message || '', {
          domain: 'src/shared/services/sendCustomActions.ts [sendCustomActions]',
          message: 'Не удалось отправить сообщение о действии с чатом',
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          errors: response.errors || ([] as any),
        });
        dispatch(showAlert({ message: 'Сервисная ошибка. Повторите попытку' }));

        return;
      }

      trackSuccessSendCustomAction(currentChat, action, companionId, opponentId);

      if (button?.successDescription) {
        dispatch(showAlert({ message: button.successDescription, type: EAlert.Info }));
      }
    } catch (error) {
      logger.error(error, {
        domain: 'src/shared/services/sendCustomActions.ts [sendCustomActions]',
        message: 'Не удалось отправить сообщение о действии с чатом',
      });
      dispatch(showAlert({ message: 'Сервисная ошибка. Повторите попытку' }));
    }
  };
